<template>
  <section id="bumiKini" ref="bumiKini" v-on:wheel="wheelChanged">
    <Header :class="{header: true}" v-on:login="$emit('login')"
      :scrolled="true"/>
    <div class="sectionNav">
      <div class="navUp" v-on:click="prevSection"
        v-if="currnetSx > 0"></div>
      <div class="navDown" v-on:click="nextSection"
        v-if="currnetSx < sxAnimate.length"></div>
    </div>
    <div :class="{sectionItem: true, section1: true, an1: sxAnimate[0].an1, an2: sxAnimate[0].an2}">
      <div class="sectionItemWrapper">
        <div class="text">
          <h3>Bumi dan Krisis Iklim</h3>
          <h4>Semua berawal dari kenaikan suhu bumi.</h4>
          <p>Terhitung sejak masa revolusi industri, suhu bumi telah meningkat sekitar
            1°C hingga saat ini.</p>
          <p>Peningkatan yang terkesan kecil, tapi cukup besar untuk memberikan dampak
            bagi perubahan siklus iklim bumi dengan efek samping yang saat ini menempatkan
            kehidupan kita pada situasi krisis.</p>
        </div>
        <div class="sectionR">
          <div :class="{sunCnt: true, an: sxAnimate[0].an2}"></div>
          <div :class="{earth: true, an: sxAnimate[0].an1, an2: sxAnimate[0].an2}"></div>
          <div :class="{termometer: true, an: sxAnimate[0].an1}">
            <img src="../assets/termometer.png"></div>
          <div :class="{cloud1: true, an: sxAnimate[0].an2}"><img src="../assets/cloud-1.png"></div>
          <div :class="{cloud2: true, an: sxAnimate[0].an2}"><img src="../assets/cloud-2.png"></div>
        </div>
      </div>
    </div>
    <div :class="{sectionItem: true, section2: true, an1: sxAnimate[1].an1, an2: sxAnimate[1].an2,
      info1: infoIdx === 0, info2: infoIdx === 1, info3: infoIdx === 2, info4: infoIdx === 3}"
      v-on:wheel.stop="sc3wheel">
      <div class="sectionItemWrapper">
        <h4 class="scTtl">Mengapa Suhu Bumi Bisa Meningkat?</h4>
        <div class="ground">
          <div class="sun"></div>
          <div class="sunRadiation"></div>
          <div class="sunRadiation2"></div>
          <div class="sunRadiation3"></div>
          <div class="sunRadiation4"></div>
          <div class="sunRadiation5"></div>
          <div class="sunRadiation6"></div>
          <div class="outerRim"></div>
          <div class="radiation"></div>
          <div class="groundBg"></div>
          <div class="extree"></div>
          <div class="building"></div>
          <div class="smoke1"></div>
          <div class="smoke2"></div>
          <div class="smoke3"></div>
          <div class="smoke1a">
            <span>CO<sub>2</sub></span>
          </div>
          <div class="smoke2a">
            <span>CO<sub>2</sub></span>
          </div>
          <div class="smoke3a">
            <span>CO<sub>2</sub></span>
          </div>
          <div class="smoke4">
            <span>CO<sub>2</sub></span>
          </div>
          <div class="wood"></div>
          <div class="buldoze"></div>
          <div class="barrel"></div>
          <div class="train"></div>
        </div>
        <div class="sectionRight">
          <div class="scR">
            <h4>Efek Rumah Kaca (GRK)</h4>
            <p>Aktifitas kita, manusia, disepakati 97% ilmuwan iklim dunia sebagai
              faktor utama</p>
            <div class="infoCnt">
              <ol>
                <li>
                  <div class="textWrapper">
                    <span>1.</span>
                    Selama ratusan tahun, manusia bergantung pada pembakaran bahan bakar
                    fosil (batubara, minyak, gas) serta penebangan hutan dalam skala besar,
                    atas nama pembangunan dan perkembangan peradaban.
                  </div>
                </li>
                <li>
                  <div class="textWrapper">
                    <span>2.</span>
                    Aktivitas tersebut kemudian melepaskan emisi GRK, khususnya karbon
                    dioksida (CO2) dalam jumlah yang melimpah ke atmosfer.
                  </div>
                </li>
                <li>
                  <div class="textWrapper">
                    <span>3.</span>
                    Gas-gas tersebut menetap di atmosfer dan menjebak panas matahari
                    hingga menghangatkan permukaan bumi, atau fenomena yang kita kenal
                    dengan Efek Rumah Kaca
                  </div>
                </li>
                <li>
                  <div class="textWrapper">
                    <span>4.</span>
                    Secara alami, GRK berguna untuk menyesuaikan suhu sehingga bumi
                    dapat menjadi layak huni. Namun, dengan terlalu banyak GRK,
                    suhu bumi justru akan terus menghangat hingga memunculkan
                    dampak-dampak berbahaya bagi seisinya.
                  </div>
                </li>
              </ol>
            </div>
            <div class="infoAction">
              <div class="infoActPrev" v-on:click="prevInfo" v-if="infoIdx > 0"></div>
              <div class="infoActNext" v-on:click="nextInfo" v-if="infoIdx < 3"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{sectionItem: true, section3: true, an1: sxAnimate[2].an1, an2: sxAnimate[2].an2}">
      <div class="sectionItemWrapper">
        <div class="sectionL">
          <h4 class="scTtl">Krisis iklim adalah masalah yang terus mengancam kita karena
            kenaikan suhu yang terus meningkat tak terkendali.</h4>
          <div class="scSubEarth">
            <p class="scSub">Sejak 2015, tahun demi tahun terus mencetak rekor suhu bumi
              terpanas, bahkan hingga 2020 lalu.</p>
            <div class="earthIcon">
              <div class="earthIcon1"></div>
              <div class="earthIcon2">
                <div class="theIcon"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="sectionR">
          <div class="theImg">
            <img src="../assets/global-surface-temperature.png">
            <div class="imgCaption">(Gabungan data 6 lembaga, Sumber:
              <span>Carbon Brief</span>)</div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{sectionItem: true, section4: true, an1: sxAnimate[3].an1, an2: sxAnimate[3].an2}">
      <div class="sectionItemWrapper">
        <div class="ayoBeraksi"></div>
        <div class="sectionR">
          <div class="infoWrapper" v-on:wheel.stop="doNothing">
            <perfect-scrollbar class="infoCnt">
              <p>Upaya pembatasan kenaikan suhu bumi, jelas menjadi langkah
                utama yang perlu kita capai bersama guna mencegah berbagai
              dampak yang jauh lebih buruk bagi masa depan kita.</p>
              <p>Menekan angka kenaikan suhu bumi di bawah 2°C, bahkan dengan
                usaha lebih untuk tetap membatasinya di bawah 1,5°C adalah
                misi yang tengah diperjuangkan oleh seisi dunia, sebagaimana
              yang telah disepakati dalam Perjanjian Paris.</p>
              <p>Aksi kita menentukan apa yang akan terjadi di masa yang akan
                datang. Saatnya membuka mata, tergerak, dan mulai memahami
                krisis iklim lebih jauh untuk mengawali aksi yang penuh arti
              bagi keselamatan bumi.</p>
            </perfect-scrollbar>
          </div>
          <div class="btn" v-on:click="$router.push('/bumi-kini/faktor-faktor')">
            <div class="btnL"></div>
            <div class="btnL2"></div>
            <span>Selanjutnya</span>
          </div>
          <div class="factor">Faktor-faktor</div>
        </div>
      </div>
    </div>
    <div class="sectionFooter"><Footer></Footer></div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'home',
  components: { Header, Footer },
  data() {
    return {
      currnetSx: 0,
      infoIdx: 0,
      sxAnimate: [
        { an1: false, an2: false },
        { an1: false, an2: false },
        { an1: false, an2: false },
        { an1: false, an2: false },
      ],
      scrolling: false,
      changingInfo: false,
    };
  },
  created() {
    window.addEventListener('scroll', this.onScrolled);
    window.addEventListener('resize', this.onResized);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScrolled);
    window.removeEventListener('resize', this.onResized);
  },
  beforeDestroy() {
    document.body.classList.remove('hideoverflow');
  },
  methods: {
    ...mapActions([
      'chMenuActive',
    ]),
    doNothing() {},
    onScrolled(e) {},
    onResized() {
      if (window.innerWidth >= 960) this.doScroll();
    },
    wheelChanged(e) {
      if (window.innerWidth <= 960) return;
      if (this.scrolling) return;
      if (e.wheelDeltaY < 0) {
        this.nextSection();
      } else if (e.wheelDeltaY > 0) {
        this.prevSection();
      }
    },
    showSection(sx) {
      this.sxAnimate[sx].an1 = true;
      setTimeout(() => {
        this.sxAnimate[sx].an2 = true;
      }, 1300);
    },
    removeAnimation(sx) {
      this.sxAnimate[sx].an2 = false;
      setTimeout(() => {
        this.sxAnimate[sx].an1 = false;
      });
    },
    nextSection() {
      this.scrolling = true;
      setTimeout(() => {
        this.scrolling = false;
      }, 1000);
      this.currnetSx += 1;
      this.doScroll();
      if (this.sxAnimate[this.currnetSx]) {
        setTimeout(() => {
          this.removeAnimation(this.currnetSx - 1);
        });
        setTimeout(() => {
          this.showSection(this.currnetSx);
        }, 1000);
      }
    },
    prevSection() {
      this.scrolling = true;
      setTimeout(() => {
        this.scrolling = false;
      }, 1000);
      if (this.currnetSx < 1) return;
      this.currnetSx -= 1;
      this.doScroll();
      if (this.sxAnimate[this.currnetSx + 1]) {
        setTimeout(() => {
          this.removeAnimation(this.currnetSx + 1);
        });
        setTimeout(() => {
          this.showSection(this.currnetSx);
        }, 300);
      }
    },
    doScroll() {
      this.infoIdx = 0;
      this.$refs.bumiKini.scroll({
        top: this.currnetSx * window.innerHeight * 86 / 100,
        left: 0,
        behavior: 'smooth',
      });
    },
    sc3wheel(e) {
      if (window.innerWidth <= 960) return;
      if (this.changingInfo || this.scrolling) return;
      if (e.wheelDeltaY < 0) {
        if (this.infoIdx > 2) this.nextSection();
        else this.nextInfo();
      } else if (e.wheelDeltaY > 0) {
        if (this.infoIdx < 1) this.prevSection();
        else this.prevInfo();
      }
    },
    nextInfo() {
      this.changingInfo = true;
      setTimeout(() => {
        this.changingInfo = false;
      }, 600);
      if (this.infoIdx > 2) return;
      this.infoIdx += 1;
    },
    prevInfo() {
      this.changingInfo = true;
      setTimeout(() => {
        this.changingInfo = false;
      }, 600);
      if (this.infoIdx < 1) return;
      this.infoIdx -= 1;
    },
  },
  mounted() {
    document.body.classList.add('hideoverflow');
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Bumi dan Krisis Iklim - Bumi Butuh Aksi';
    this.showSection(0);
    this.chMenuActive('bumi-kini');
  },
};
</script>

<style lang="scss">
.section4{
  .sectionR{
    .infoCnt{
      .ps__rail-y{
        background: #fff !important;
        border-radius: 40px;
        width: 8px;
        opacity: 1;
        right: 4px !important;
        .ps__thumb-y{
          background-color: #FFE06A !important;
          width: 16px;
          right: -4px;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
.sectionNav{
  position: absolute;
  left: 50%; bottom: 6vh;
  margin-left: -40px;
  z-index: 99;
  width: 80px;
  height: 36px;
  @media (max-width: 960px) {
    display: none;
  }
  .navUp{
    width: 36px; height: 36px;
    border: #fff 2px solid;
    border-radius: 23px;
    box-sizing: border-box;
    position: absolute; left: 0; bottom: 0;
    transition: all .2s ease;
    cursor: pointer;
    background-image: url(../assets/arrow-up-white.png);
    background-position: center;
    background-size: 18px auto;
    background-repeat: no-repeat;
    &:hover{
      height: 46px;
    }
  }
  .navDown{
    width: 36px; height: 36px;
    border: #fff 2px solid;
    border-radius: 23px;
    box-sizing: border-box;
    position: absolute; right: 0; top: 0;
    transition: all .2s ease;
    cursor: pointer;
    background-image: url(../assets/arrow-down-white.png);
    background-position: center;
    background-size: 18px auto;
    background-repeat: no-repeat;
    &:hover{
      height: 46px;
    }
  }
}
.section1{
  background-color: #009B4B;
  // background-image: url(../assets/texture-bg.png);
  overflow: hidden;
  @media (max-width: 960px) {
    padding-bottom: 400px;
  }
  @media (max-width: 680px) {
    padding-bottom: 240px;
  }
  .sectionR{
    position: relative;
    height: 100%;
    transform: scale(0.84) translate(100px, 40px);
    @media (max-width: 1369px) {
      transform: scale(0.7) translate(240px, 80px);
    }
    @media (max-width: 960px) {
      transform: scale(0.7);
      position: absolute;
      left: 0; right: 0; bottom: -160px;
    }
    @media (max-width: 680px) {
      transform: scale(0.44);
      left: 310px;
      bottom: -200px;
    }
  }
  .text{
    position: absolute;
    left: 100px; top: 50%;
    transform: translateY(-50%);
    max-width: 580px;
    color: #fff;
    z-index: 10;
    @media (max-width: 1169px) {
      left: 60px;
      max-width: 400px;
    }
    @media (max-width: 960px) {
      position: static;
      top: 60px; transform: none;
      max-width: none;
      padding: 40px;
    }
    @media (max-width: 680px) {
      padding: 30px 16px;
    }
    h3{
      font-size: 70px;
      line-height: 1.1;
      margin: 0;
      margin-left: -5px;
      transform: translateX(-700px);
      font-weight: 800;
      max-width: 400px;
      opacity: 0;
      transition: all .9s ease;
      @media (max-width: 1169px) {
        font-size: 64px;
      }
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
      @media (max-width: 680px) {
        font-size: 40px;
      }
    }
    h4{
      text-transform: uppercase;
      color: #DEE47D;
      font-size: 24px;
      transform: translateX(-700px);
      opacity: 0;
      transition: all .9s ease;
      @media (max-width: 1169px) {
        font-size: 20px;
      }
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
    }
    p{
      transform: translateX(-700px);
      transition: all .9s ease;
      opacity: 0;
      font-size: 18px;
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
    }
  }
  &.an1{
    .text{
      h3{
        transform: none;
        opacity: 1;
      }
    }
  }
  &.an2{
    .text{
      h4, p{
        transform: none;
        opacity: 1;
      }
    }
  }
  .sunCnt{
    width: 600px; height: 600px;
    position: absolute;
    right: 40px; bottom: -200px;
    transform: rotate(-80deg);
    transition: all .9s ease;
    opacity: 0;
    &:before{
      position: absolute;
      width: 200px; height: 200px;
      background-image: url(../assets/sun.png);
      background-size: 100% auto;
      background-position: center;
      background-repeat: no-repeat;
      left: -120px; top: -120px;
      content: "";
      display: block;
    }
    &.an{
      transform: rotate(0deg);
      opacity: 1;
    }
    @media (max-width: 960px) {
      transform: rotate(0deg);
      opacity: 1;
    }
  }
  .earth{
    width: 600px; height: 600px;
    background-color: #6CD9EA;
    border-radius: 50%;
    position: absolute;
    right: 40px; bottom: -600px;
    background-image: url(../assets/world-map.png);
    background-size: auto 100%;
    background-position: -100px 50%;
    transition: all .9s ease;
    &.an{
      bottom: -200px;
    }
    &.an2{
      background-position: -390px 50%;
    }
    @media (max-width: 960px) {
      bottom: -200px;
      background-position: -390px 50%;
    }
  }
  .termometer{
    position: absolute;
    right: 50px; bottom: 90px;
    transform: translateY(400px);
    opacity: 0;
    transition: all .9s ease;
    &.an{
      transform: none;
      opacity: 1;
    }
    img{
      width: 120px;
    }
    @media (max-width: 960px) {
      opacity: 1;
      transform: none;
    }
  }
  .cloud1{
    position: absolute;
    right: 400px; bottom: 280px;
    opacity: 0;
    transition: all .9s ease;
    right: 640px;
    img{
      height: 80px;
    }
    &.an{
      right: 400px;
      opacity: 1;
    }
    @media (max-width: 960px) {
      opacity: 1;
      right: 400px;
    }
  }
  .cloud2{
    position: absolute;
    right: 80px; bottom: 540px;
    opacity: 0;
    transition: all .9s ease;
    right: -120px;
    img{
      height: 70px;
    }
    &.an{
      right: 80px;
      opacity: 1;
    }
    @media (max-width: 960px) {
      opacity: 1;
      right: 80px;
    }
  }
}
.section2{
  background-color: #49C2CC;
  overflow: hidden;
  @media (max-width: 960px) {
    padding-bottom: 400px;
  }
  @media (max-width: 680px) {
    padding-bottom: 300px;
  }
  .ground{
    width: 1000px; height: 1000px;
    position: absolute;
    left: -20px; bottom: -740px;
    z-index: 1;
    @media (max-width: 1369px) {
      transform: scale(0.9) translate(-30px, -30px);
    }
    @media (max-width: 1169px) {
      transform: scale(0.76) translate(-250px, -90px);
    }
    @media (max-width: 960px) {
      left: 50%; bottom: -650px;
      transform: scale(0.76) translateX(-50%);
      margin-left: -120px;
    }
    @media (max-width: 680px) {
      transform: scale(0.46) translateX(-50%);
      margin-left: -280px; bottom: -600px;
    }
    .sunRadiation{
      position: absolute;
      top: -260px; left: 175px;
      width: 120px; height: 0;
      z-index: 9;
      background-size: 100% auto;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../assets/sun-radiation.png);
      transition: all .9s ease;
      opacity: 0;
    }
    .sunRadiation2{
      position: absolute;
      bottom: 962px; left: 633px;
      width: 0; height: 0;
      z-index: 9;
      background-size: auto 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../assets/sun-radiation2.png);
      transition: all .9s ease;
      opacity: 0;
    }
    .sunRadiation3{
      position: absolute;
      top: -198px; left: 782px;
      width: 0; height: 0;
      z-index: 9;
      background-size: auto 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../assets/sun-radiation3.png);
      transition: all .9s ease;
      opacity: 0;
    }
    .sunRadiation4{
      position: absolute;
      top: -232px; left: 265px;
      width: 0; height: 0;
      z-index: 9;
      background-size: auto 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../assets/sun-radiation4.png);
      transition: all .9s ease;
      opacity: 0;
    }
    .sunRadiation5{
      position: absolute;
      bottom: 888px; left: 624px;
      width: 0; height: 0;
      z-index: 9;
      background-size: auto 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../assets/sun-radiation5.png);
      transition: all .9s ease;
      opacity: 0;
    }
    .sunRadiation6{
      position: absolute;
      width: 1900px; height: 1900px;
      z-index: 8;
      left: 50%; top: 50%;
      transform: translate(-50%, -50%);
      transition: all .9s ease;
      background-image: url(../assets/sun-radiation-bg.png);
      background-size: 100%;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0;
    }
    .sun{
      position: absolute;
      border-radius: 50%;
      width: 1700px; height: 1700px;
      left: 50%; top: 50%;
      transform: translate(-50%, -50%) rotate(-20deg);
      transition: all .9s ease;
      opacity: 0;
      z-index: 8;
      &:before{
        content: "";
        width: 140px; height: 140px;
        background-size: 100% auto;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/sun.png);
        transition: all .9s ease;
        position: absolute;
        left: 480px; top: 0;
      }
    }
    .radiation{
      position: absolute;
      border-radius: 50%;
      width: 1300px; height: 1300px;
      left: 50%; top: 50%;
      transform: translate(-50%, -50%) scale(.6);
      transition: all .9s ease;
      background-image: url(../assets/radiation.png);
      background-size: 100%;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0;
    }
    .outerRim{
      position: absolute;
      border-radius: 50%;
      width: 1700px; height: 1700px;
      left: 50%; top: 50%;
      transform: translate(-50%, -50%) scale(0);
      transition: all .9s ease;
      background-image: url(../assets/outer-rim.png);
      background-size: 100%;
      background-position: center;
      background-repeat: no-repeat;
    }
    .groundBg{
      position: absolute;
      background-color: #098C7F;
      border-radius: 50%;
      left: 0; top: 0; right: 0; bottom: 0;
      opacity: 0;
      transform: scale(0.5);
      transition: all .9s ease;
    }
    .extree{
      position: absolute;
      left: 200px; right: 200px; top: 100px;
      height: 140px;
      background-image: url(../assets/ex-tree.png);
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: center;
      transition: all .9s ease;
      transform: scale(0.5);
      opacity: 0;
    }
    .building{
      position: absolute;
      left: 200px; top: -160px;
      width: 400px; height: 300px;
      background-image: url(../assets/building.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .9s ease;
      z-index: 3;
      transform: translateY(200px);
      opacity: 0;
    }
    .smoke1{
      position: absolute;
      left: 237px; top: -145px;
      width: 110px; height: 160px;
      background-image: url(../assets/smoke1.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      transition: all .9s ease;
      transform: scale(.5) translateY(80px) translateX(-16px);
      opacity: 0;
      z-index: 1;
    }
    .smoke1a{
      position: absolute;
      left: 223px; top: -165px;
      width: 120px; height: 200px;
      background-image: url(../assets/smoke1a.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      transition: all .5s ease;
      opacity: 0;
      z-index: 1;
      span{
        color: #fff;
        font-size: 20px;
        position: absolute;
        top: 74px; left: 40px;
        transform: translateY(40px) translateX(-10px);
        transition: all .9s ease;
      }
    }
    .smoke2{
      position: absolute;
      left: 374px; top: -215px;
      width: 80px; height: 126px;
      background-image: url(../assets/smoke2.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      transition: all .9s ease;
      transform: scale(.5) translateY(64px) translateX(8px);
      opacity: 0;
      z-index: 1;
    }
    .smoke2a{
      position: absolute;
      left: 381px; top: -231px;
      width: 80px; height: 146px;
      background-image: url(../assets/smoke2a.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      transition: all .5s ease;
      opacity: 0;
      z-index: 1;
      span{
        color: #fff;
        font-size: 20px;
        position: absolute;
        top: 62px; left: 25px;
        transform: translateY(40px) translateX(-10px);
        transition: all .9s ease;
      }
    }
    .smoke3{
      position: absolute;
      left: 446px; top: -215px;
      width: 80px; height: 126px;
      background-image: url(../assets/smoke3.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .9s ease;
      transform: scale(.5) translateY(64px) translateX(-12px);
      opacity: 0;
      z-index: 1;
    }
    .smoke3a{
      position: absolute;
      left: 454px; top: -251px;
      width: 80px; height: 166px;
      background-image: url(../assets/smoke3a.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .5s ease;
      opacity: 0;
      z-index: 1;
      span{
        color: #fff;
        font-size: 20px;
        position: absolute;
        top: 67px; left: 23px;
        transform: translateY(40px) translateX(-10px);
        transition: all .9s ease;
      }
    }
    .smoke4{
      position: absolute;
      left: 662px; top: -30px;
      width: 80px; height: 136px;
      background-image: url(../assets/smoke4a.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .5s ease;
      opacity: 0;
      z-index: 1;
      span{
        color: #fff;
        font-size: 20px;
        position: absolute;
        top: 60px; left: 30px;
        transform: translateY(40px) translateX(-10px);
        transition: all .9s ease;
      }
    }
    .wood{
      position: absolute;
      right: 220px; top: 100px;
      width: 180px; height: 100px;
      background-image: url(../assets/wood.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .9s ease;
      opacity: 0;
      z-index: 4;
    }
    .buldoze{
      position: absolute;
      left: 440px; top: 140px;
      width: 200px; height: 110px;
      background-image: url(../assets/buldoze.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .9s ease;
      transform: translateX(-300px);
      opacity: 0;
      z-index: 4;
    }
    .barrel{
      position: absolute;
      left: 320px; top: 120px;
      width: 80px; height: 80px;
      background-image: url(../assets/barrel.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .9s ease;
      opacity: 0;
      z-index: 4;
    }
    .train{
      position: absolute;
      left: 180px; top: 160px;
      width: 140px; height: 80px;
      background-image: url(../assets/train.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .9s ease;
      transform: translateX(-300px);
      opacity: 0;
      z-index: 4;
    }
    @media (max-width: 960px) {
      opacity: 1;
      .outerRim{
        transform: translate(-50%, -50%) scale(0.6);
      }
      .groundBg, .extree, .building, .train, .barrel, .wood, .buldoze,
      .smoke1, .smoke2, .smoke3{
        opacity: 1;
        transform: none;
      }
      .sun{
        transform: translate(-50%, -50%) rotate(0deg);
        opacity: 1;
      }
    }
  }
  .scTtl{
    color: #555A84;
    text-transform: uppercase;
    font-size: 30px;
    font-weight: 800;
    position: absolute;
    left: 100px; top: 40px;
    z-index: 2;
    transform: translateX(-600px);
    opacity: 0;
    transition: all .9s ease;
    @media (max-width: 1169px) {
      left: 60px; top: 20px;
    }
    @media (max-width: 960px) {
      position: static;
      transform: none;
      opacity: 1;
      margin: 0;
      padding: 40px 40px 20px;
    }
    @media (max-width: 680px) {
      padding: 30px 16px 16px;
      font-size: 20px;
    }
  }
  .sectionRight{
    position: absolute;
    top: 0; bottom: 0; left: 50%;
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 0 60px;
    max-width: 760px;
    color: #fff;
    z-index: 9;
    @media (max-width: 1169px) {
      width: 640px;
      left: auto; right: 0;
    }
    @media (max-width: 960px) {
      position: relative;
      left: auto; right: auto; bottom: auto;
      padding: 0 40px 100px;
    }
    @media (max-width: 960px) {
      padding: 0 16px;
      width: auto;
    }
    h4{
      font-size: 28px;
      margin: 0 0 20px;
      transform: translateX(600px);
      opacity: 0;
      transition: all .9s ease;
      @media (max-width: 1169px) {
        font-size: 24px;
        margin: 0 0 10px;
      }
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
      @media (max-width: 680px) {
        font-size: 20px;
      }
    }
    p{
      font-size: 20px;
      margin: 0 0 40px;
      transform: translateX(600px);
      opacity: 0;
      transition: all .9s ease;
      @media (max-width: 1169px) {
        font-size: 18px;
        margin: 0 0 20px;
      }
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
      @media (max-width: 680px) {
        font-size: 16px;
      }
    }
    .infoCnt{
      background-color: #555A84;
      color: #fff;
      border-radius: 15px;
      height: 240px;
      box-sizing: border-box;
      padding: 0 60px;
      font-size: 18px;
      line-height: 1.4;
      overflow: hidden;
      transform: translateX(600px);
      opacity: 0;
      transition: all .9s ease;
      @media (max-width: 1169px) {
        padding: 0 40px;
      }
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
      @media (max-width: 680px) {
        // height: 300px;
        padding: 0 20px;
        padding-right: 10px;
        font-size: 16px;
        line-height: 1.3;
      }
      ol{
        margin: 0; padding: 0;
        transition: all .6s ease;
      }
      li{
        padding: 0;
        padding-left: 30px;
        height: 240px;
        display: flex;
        align-items: center;
        @media (max-width: 680px) {
          // height: 300px;
        }
        .textWrapper{
          position: relative;
          span{
            position: absolute;
            left: -34px; top: 0;
          }
        }
      }
    }
  }
  .infoAction{
    float: right;
    position: relative;
    margin-top: 20px;
    width: 120px;
    background-color: green;
    margin-right: 16px;
    transform: translateX(600px);
    opacity: 0;
    transition: all .9s ease;
    @media (max-width: 960px) {
      opacity: 1;
      transform: none;
    }
    .infoActPrev{
      width: 46px; height: 46px;
      background-color: #A4453F;
      border-radius: 23px;
      position: absolute;
      right: 64px; top: 0;
      cursor: pointer;
      transition: all .2s ease;
      background-image: url(../assets/arrow-left-white.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      &:hover{
        width: 64px;
      }
    }
    .infoActNext{
      width: 46px; height: 46px;
      background-color: #A4453F;
      border-radius: 23px;
      position: absolute;
      left: 64px; top: 0;
      cursor: pointer;
      transition: all .2s ease;
      background-image: url(../assets/arrow-right-white.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      &:hover{
        width: 64px;
      }
    }
  }
  &.an1{
    .scTtl{
      transform: none;
      opacity: 1;
    }
    .sectionRight{
      h4, p{
        transform: none;
        opacity: 1;
      }
    }
    .ground{
      .outerRim{
        transform: translate(-50%, -50%) scale(0.6);
      }
      .groundBg, .extree, .building, .train, .barrel, .wood, .buldoze{
        opacity: 1;
        transform: none;
      }
    }
  }
  &.an2{
    .sectionRight{
      .infoCnt, .infoAction{
        transform: none;
        opacity: 1;
      }
    }
    .ground{
      .sun{
        transform: translate(-50%, -50%) rotate(0deg);
        opacity: 1;
      }
      .smoke1, .smoke2, .smoke3{
        opacity: 1;
        transform: none;
      }
    }
  }
  &.info2{
    .sectionRight .infoCnt ol{
      margin-top: -240px;
    }
    .ground{
      .sun{
        &:before{
          transform: rotate(-135deg);
        }
      }
      .outerRim{
        transform: translate(-50%, -50%) scale(1);
        opacity: 1;
      }
      .smoke1, .smoke2, .smoke3{
        transition: all .9s ease;
        opacity: 0;
      }
      .smoke1a, .smoke2a, .smoke3a, .smoke4{
        opacity: 1;
        transition: all .9s ease;
        span{
          transform: none;
        }
      }
    }
  }
  &.info3{
    .sectionRight .infoCnt ol{
      margin-top: -480px;
    }
    .ground{
      .sun{
        &:before{
          transform: rotate(-270deg);
        }
      }
      .sunRadiation{
        width: 480px; height: 360px;
        opacity: 1;
      }
      .sunRadiation2{
        width: 190px; height: 240px;
        opacity: 1;
      }
      .sunRadiation3{
        width: 20px; height: 280px;
        opacity: 1;
      }
      .outerRim{
        transform: translate(-50%, -50%) scale(1) rotate(-45deg);
      }
      .radiation{
        transform: translate(-50%, -50%) scale(1) rotate(45deg);
        opacity: 1;
      }
      .smoke1, .smoke2, .smoke3{
        transition: all .9s ease;
        opacity: 0;
      }
      .smoke1a, .smoke2a, .smoke3a, .smoke4{
        opacity: 1;
        transition: all .9s ease;
        span{
          transform: none;
        }
      }
    }
  }
  &.info4{
    .sectionRight .infoCnt ol{
      margin-top: -720px;
    }
    .ground{
      .sun{
        &:before{
          transform: rotate(-405deg);
        }
      }
      .sunRadiation{
        width: 480px; height: 360px;
        opacity: 1;
      }
      .sunRadiation2{
        width: 190px; height: 240px;
        opacity: 1;
      }
      .sunRadiation3{
        width: 20px; height: 280px;
        opacity: 1;
      }
      .sunRadiation4{
        width: 380px; height: 340px;
        opacity: 1;
      }
      .sunRadiation5{
        width: 210px; height: 480px;
        opacity: 1;
      }
      .sunRadiation6{
        transform: translate(-50%, -50%) rotate(90deg);
        opacity: 1;
      }
      .outerRim{
        transform: translate(-50%, -50%) scale(1) rotate(-90deg);
      }
      .radiation{
        transform: translate(-50%, -50%) scale(1) rotate(45deg);
        opacity: 1;
      }
      .smoke1, .smoke2, .smoke3{
        transition: all .9s ease;
        opacity: 0;
      }
      .smoke1a, .smoke2a, .smoke3a, .smoke4{
        opacity: 1;
        transition: all .9s ease;
        span{
          transform: none;
        }
      }
    }
  }
}
.section3{
  background-color: #097265;
  .sectionL{
    position: absolute;
    left: 100px; top: 50%;
    width: 520px;
    transform: translate(-600px, -50%);
    opacity: 0;
    transition: all .9s ease;
    @media (max-width: 1169px) {
      left: 60px;
      width: 340px;
    }
    @media (max-width: 960px) {
      position: static;
      opacity: 1; width: auto;
      transform: none !important;
      padding: 40px;
    }
    @media (max-width: 680px) {
      padding: 30px 16px;
    }
    .scTtl{
      color: #DEE47D;
      text-transform: uppercase;
      font-size: 26px;
      font-weight: 800;
      margin: 0 0 20px;
      @media (max-width: 1169px) {
        font-size: 20px;
        margin: 0 0 40px;
      }
    }
    .scSubEarth{
      @media (max-width: 960px) {
        position: relative;
        min-height: 260px;
      }
      @media (max-width: 680px) {
        min-height: 150px;
      }
    }
    .scSub{
      color: #fff;
      font-size: 20px;
      margin: 0 0 40px;
      @media (max-width: 1169px) {
        font-size: 17px;
      }
      @media (max-width: 960px) {
        padding-left: 260px;
      }
      @media (max-width: 680px) {
        padding-left: 148px;
      }
    }
    .earthIcon{
      margin-top: 40px;
      width: 220px;
      height: 220px;
      position: relative;
      @media (max-width: 960px) {
        position: absolute;
        left: 0; top: 0;
        margin-top: 0;
      }
      @media (max-width: 680px) {
        width: 120px; height: 120px;
      }
      .earthIcon1{
        position: absolute;
        left: 0; top: 0;
        width: 220px;
        height: 220px;
        background-image: url(../assets/earth-1.png);
        background-size: 100% auto;
        background-repeat: no-repeat;
        z-index: 2;
        @media (max-width: 680px) {
          width: 120px; height: 120px;
        }
      }
      .earthIcon2{
        position: absolute;
        left: 0; top: 130px; right: 0;
        height: 300px;
        overflow: hidden;
        @media (max-width: 680px) {
          height: 180px;
          top: 0;
        }
        .theIcon{
          transform: translateY(-70px);
          position: absolute;
          transition: all .9s ease;
          top: -130px;
          width: 220px;
          height: 340px;
          background-image: url(../assets/bumi-leleh.png);
          background-size: 100% auto;
          background-repeat: no-repeat;
          @media (max-width: 960px) {
            transform: none;
          }
          @media (max-width: 680px) {
            width: 120px;
            height: 180px;
            top: 0;
          }
        }
      }
    }
  }
  .sectionR{
    transition: all .9s ease;
    transform: translateX(600px);
    opacity: 0;
    width: calc(100% - 760px);
    position: absolute;
    right: 100px; top: 60px; bottom: 60px;
    display: flex;
    align-items: center;
    @media (max-width: 1169px) {
      width: calc(100% - 520px);
      right: 60px;
    }
    @media (max-width: 960px) {
      width: auto;
      position: static;
      transform: none;
      padding: 0 40px 60px;
      opacity: 1;
    }
    @media (max-width: 680px) {
      padding: 0 16px 30px;
    }
    .theImg{
      img{
        width: 100%; height: auto;
      }
      .imgCaption{
        color: #fff;
        text-align: right;
        font-size: 14px;
        margin-top: 8px;
        transform: translateX(600px);
        opacity: 0;
        transition: all .9s ease;
        span{
          color: #DEE47D;
        }
        @media (max-width: 960px) {
          opacity: 1;
          transform: none;
        }
      }
    }
  }
  &.an1{
    .sectionL{
      opacity: 1;
      transform: translateY(-50%);
    }
    .sectionR{
      opacity: 1;
      transform: none;
    }
  }
  &.an2{
    .sectionL{
      .earthIcon{
        .earthIcon2{
          .theIcon{
            transform: none;
          }
        }
      }
    }
    .sectionR{
      .theImg{
        .imgCaption{
          opacity: 1;
          transform: none;
        }
      }
    }
  }
}
.section4{
  background-color: #555A84;
  @media (max-width: 960px) {
    padding: 60px 40px 400px;
  }
  @media (max-width: 680px) {
    padding: 30px 16px 400px;
  }
  .ayoBeraksi{
    width: calc(100% - 840px);
    position: absolute;
    left: 100px; top: 0; bottom: 0;
    background-image: url(../assets/ayo-beraksi.png);
    background-size: contain;
    background-position: bottom center;
    background-repeat: no-repeat;
    opacity: 0;
    transform: translateY(86vh);
    transition: all .9s ease;
    @media (max-width: 1169px) {
      width: auto;
      left: 400px; right: 0; top: 100px;
    }
    @media (max-width: 960px) {
      opacity: 1;
      transform: none;
      left: 0; top: auto; bottom: 0; height: 360px;
    }
  }
  .sectionR{
    position: absolute;
    right: 100px; top: 60px;
    width: 600px;
    @media (max-width: 1169px) {
      right: auto; top: 40px; left: 60px;
    }
    @media (max-width: 960px) {
      position: static;
      width: auto;
    }
    .infoWrapper{
      background-color: #35395E;
      color: #fff;
      height: 400px;
      border-radius: 15px;
      padding: 20px 60px;
      box-sizing: border-box;
      margin-bottom: 60px;
      opacity: 0;
      transform: translateX(460px);
      transition: all .9s ease;
      @media (max-width: 960px) {
        transform: none;
        opacity: 1;
        margin-bottom: 40px;
      }
      @media (max-width: 680px) {
        height: auto;
        padding: 10px 24px;
      }
      .infoCnt{
        font-size: 20px;
        line-height: 1.5;
        height: 360px;
        padding-right: 50px;
        @media (max-width: 680px) {
          height: auto;
          font-size: 16px;
          padding: 0;
        }
      }
    }
    .factor{
      color: #FFE06A;
      font-size: 24px;
      font-weight: 800;
      margin: 10px 0 0 20px;
      opacity: 0;
      transform: translateX(200px);
      transition: all .9s ease;
      @media (max-width: 960px) {
        transform: none;
        opacity: 1;
      }
    }
    .btn{
      margin-left: 20px;
      opacity: 0;
      transform: translateX(200px);
      transition: all .9s ease;
      @media (max-width: 960px) {
        transform: none;
        opacity: 1;
      }
    }
  }
  &.an1{
    .ayoBeraksi{
      opacity: 1;
      transform: none;
    }
    .sectionR{
      .infoWrapper{
        opacity: 1;
        transform: none;
      }
    }
  }
  &.an2{
    .sectionR{
      .factor, .btn{
        opacity: 1;
        transform: none;
      }
    }
  }
}
#bumiKini{
  padding-top: 80px;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  @media (max-width: 960px) {
    overflow: auto;
  }
  @media (max-width: 768px) {
    padding-top: 64px;
  }
}
.sectionItem{
  height: 86vh;
  // background-image: url(../assets/texture-bg.png);
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
  .sectionItemWrapper{
    position: relative;
    height: 100%;
    max-width: 1690px;
    margin: 0 auto;
    @media (max-width: 960px) {
      position: static;
    }
  }
  @media (max-width: 960px) {
    height: auto;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1.9s ease;
  overflow: hidden;
  visibility: visible;
  position: absolute;
  width:100%;
  opacity: 1;
}
.fade-enter,
.fade-leave-to {
  visibility: hidden;
  width:100%;
  opacity: 0;
}
.section{
  max-width: 1240px;
  margin: 0 auto;
  padding: 60px 0;
}
</style>
